import React from 'react';

const FleetShowcase = () => {
  const vehicles = [
    {
      type: 'Hatchback',
      models: 'Swift, i20, Altroz',
      icon: 'directions_car',
      image: '/fleet_hatchback.webp',
      features: ['4 Seats', 'AC', 'GPS'],
      usage: 'Daily commute, 1-3 employees'
    },
    {
      type: 'Sedan',
      models: 'Dzire, Honda Amaze, Aura',
      icon: 'minor_crash',
      image: '/fleet_sedan.webp',
      features: ['4 Seats', 'Premium', 'GPS'],
      usage: 'Office commutes + airport'
    },
    {
      type: 'SUV / MUV',
      models: 'Innova Crysta, Ertiga',
      icon: 'airport_shuttle',
      image: '/fleet_suv.webp',
      features: ['6-7 Seats', 'Executive', 'GPS'],
      usage: 'Executive + group travel'
    }
  ];

  return (
    <section className="py-[40px] bg-white" id="fleet">
      <div className="max-w-[1400px] mx-auto px-[32px]">
        <div className="text-center mb-[40px] w-full flex flex-col items-center">
          <h2 className="font-headline text-[36px] font-extrabold tracking-tight text-on-surface">A Fleet Built for Every Team</h2>
          <p className="text-on-surface-variant mt-[16px] max-w-[672px] mx-auto text-center">From daily office commutes to luxury airport transfers, we offer a diverse range of vehicles to meet your corporate requirements.</p>
        </div>
        <div className="grid md:grid-cols-3 gap-[24px]">
          {vehicles.map((v, i) => (
            <div key={i} className="bg-surface-container-low rounded-[16px] p-[24px] border border-outline-variant/20 hover:border-primary transition-all">
              <div className="h-[176px] bg-white rounded-[12px] mb-[24px] overflow-hidden flex items-center justify-center">
                <img
                  src={v.image}
                  alt={v.type}
                  className="w-full h-full object-cover object-center"
                />
              </div>
              <h4 className="font-bold text-[18px] mb-[4px]">{v.type}</h4>
              <p className="text-[12px] text-on-surface-variant mb-[16px]">{v.models}</p>
              <div className="flex flex-wrap gap-[8px] mb-[24px]">
                {v.features.map((f, j) => (
                  <span key={j} className="px-[8px] py-[4px] bg-white rounded-full text-[10px] font-bold uppercase tracking-wider border border-outline-variant/30">{f}</span>
                ))}
              </div>
              <p className="text-[14px] text-on-surface-variant font-medium">{v.usage}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FleetShowcase;


